import { useMemo } from 'react';
import { faCube, faShoePrints } from '@fortawesome/pro-light-svg-icons';
import { Stack } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { ISidebarSectionItem } from './SidebarSection';
import { SidebarSection } from './SidebarSection';

export type IPersonalSidebarContentProps = IContainerProps;

export const PersonalSidebarContent: React.FC<IPersonalSidebarContentProps> = (
  props,
) => {
  const { ...other } = props;
  const { t } = useTranslation();

  const items = useMemo<Array<ISidebarSectionItem>>(
    () => [
      {
        label: t('common.onboarding'),
        faLeadingIcon: faShoePrints,
        href: '/onboarding',
      },
      {
        label: t('PersonalSidebarContent.applications'),
        faLeadingIcon: faCube,
        href: '/apps',
      },
    ],
    [t],
  );

  return (
    <Stack gap={6} {...other}>
      <SidebarSection items={items} />
    </Stack>
  );
};
